import Avatar from '@material-ui/core/Avatar';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import React, { useState } from 'react';

import CropImage from '../../../shared/form/cropImage/cropButton';
import useStyles from './styles';
import CompartilharCard from '../../quemEQuem/card/compartilhar';
import {compartilharDetalhamento} from "../../../../services/usuario/UsuarioService";

const CabecalhoEdicao = (props) => {
  const {
    form, showSaveButton, tipoPerfil, userId, isEditar
  } = props;
  const classes = useStyles();
  const [openCompartilhar, setOpenCompartilhar] = useState(false);
  const [compartilharCard, setCompartilharCard] = useState(undefined);

  const handleOpenCompartilhar = async () => {
    setCompartilharCard(() => compartilharDetalhamento);
    setOpenCompartilhar(true)
    console.log(compartilharCard)
  };

  return (
    <div className={classes.cabecalho}>

      <div style={{ display: 'flex' }}>
        {form.avatar ? <Avatar alt="Avatar" src={form.avatar} className={classes.avatar} />
          : (
            <div
              className={classes.imagemReplaceFoto}
            >
              {form.nome ? form.nome.substring(0, 2).toUpperCase() : 'US'}
            </div>
          )}
        <div className={classes.itens}>
          <p className={classes.formularioTitulo}>
            {form.nome}
            {' '}
            {form.sobrenome}
          </p>
          {showSaveButton ? <CropImage /> : ''}
        </div>
      </div>
      {!isEditar && !showSaveButton && <ShareOutlinedIcon className={classes.shareButton} onClick={handleOpenCompartilhar} />}
      {compartilharCard !== undefined
        ? (
          <CompartilharCard
            open={openCompartilhar}
            onClose={() => setOpenCompartilhar(false)}
            onCompartilharCard={compartilharCard}
            id={userId}
          />
        ) : null}
    </div>
  )
};

export default CabecalhoEdicao;
